export const CLOSE_MODAL = "gdpr/CLOSE_MODAL";
export const OPEN_MODAL = "gdpr/OPEN_MODAL";
export const SET_GDPR = "gdpr/SET_GDPR";
export const SET_FIELD = "gdpr/SET_FIELD";
export const SET_SAVE_STATUS = "gdpr/SET_SAVE_STATUS";
export const SET_STATUS = "gdpr/SET_STATUS";
